import Entity from './entity'
export default class PaymentSetting extends Entity<number>{
    name:string;
    isActive:boolean;
  
}